import axiosInstance from '@/utils/api.js'

var state = {
  documents: []
}

var getters = {

  DOCUMENTS: (state) => {
    return state.documents
  }
}

var mutations = {
  SET_DOCUMENTS: (state, payload) => {
    state.documents = payload
  }
}

var actions = {
  GET_DOCUMENTS: async (context, payload) => {
    let result = await axiosInstance.get('/reports/invoices_doc_list?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&account_id=0&type=' + payload.type +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_DOCUMENTS', result.data)
    }
  },
  CLEAR_DOCUMETNS: (context) => {
    context.commit('SET_DOCUMENTS', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/documents.js